import { productSkuIds, EarlyTerminationTC, T_Coupon, T_OrderProduct, T_VC_ProductType, categoryIds, T_Order } from '@sky-tv-group/shared';
import { T_VC_DeviceType } from '@sky-tv-group/shared/src/types';

export let getEarlyTerminationTCs = (product: T_OrderProduct, coupons: T_Coupon[]) => {
  // if its starter and no coupons applied
  if (product.product.sku === productSkuIds.starter.primary && coupons.length === 0) {
    return EarlyTerminationTC;
  } else return '';
};

type T_CartProductAndDeviceType = {
  calculatedJourneyType: T_VC_ProductType | null;
  calculatedDeviceType: T_VC_DeviceType | null;
  isBundleProductInCart: boolean;
};

export const getCartProductAndDeviceType = (
  order: T_Order | undefined
): T_CartProductAndDeviceType => {

  let calculatedJourneyType: T_VC_ProductType | null = null;
  let calculatedDeviceType: T_VC_DeviceType | null = null;

  const isBBProductInCart =
    order?.orderProducts?.some(p => p.categoryId === categoryIds?.broadband) ?? false;

  const isDTHProductInCart =
    order?.orderProducts?.some(p => p.categoryId === categoryIds?.package) ?? false;

  const isProductInCart = (skuString?: string) =>
    order?.orderProducts?.some(p =>
      skuString
        ?.split(',')
        .map(s => s.trim())
        .includes(p?.product?.sku ?? '')
    ) ?? false;

  const isSkyPodProductInCart = isProductInCart(productSkuIds?.skyPod?.primary);
  const isSkyBOXProductInCart = isProductInCart(productSkuIds?.arrowBox?.primary);

  // Journey Type
  if (isBBProductInCart && isDTHProductInCart) {
    calculatedJourneyType = T_VC_ProductType.DTH_AND_BROADBAND;
  } else if (isBBProductInCart) {
    calculatedJourneyType = T_VC_ProductType.BROADBAND;
  } else if (isDTHProductInCart) {
    calculatedJourneyType = T_VC_ProductType.DTH;
  }

  // Device Type
  if (calculatedJourneyType === T_VC_ProductType.DTH || calculatedJourneyType === T_VC_ProductType.DTH_AND_BROADBAND) {
    if (isSkyPodProductInCart && isSkyBOXProductInCart) {
      calculatedDeviceType = T_VC_DeviceType.ANY;
    } else if (isSkyPodProductInCart) {
      calculatedDeviceType = T_VC_DeviceType.POD;
    } else if (isSkyBOXProductInCart) {
      calculatedDeviceType = T_VC_DeviceType.NSB;
    }
  }

  const bundleSkus = productSkuIds.skyBundles.primary.split(",");
  const findAllBundleProducts = order?.orderProducts?.filter(p => bundleSkus.includes(p?.product?.sku)) ?? [];

  return {
    calculatedJourneyType,
    calculatedDeviceType,
    isBundleProductInCart: findAllBundleProducts.length === 1 ? true : false
  };
};

export const splitVoucherCoupons = (coupons: string[]) => {
  const bbCoupon = coupons.find(c => c.includes("BB"));
  const dthCoupon = coupons.find(c => !c.includes("BB"));

  return {
    bbCoupon,
    dthCoupon
  };
};